import '../../css/Loading.css'
function Loading() {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
            <p>המידע נטען</p>
        </div>
    );
}
export default Loading;